import { lazy } from 'react'

export const DownloadApp = lazy(() => import('./DownloadApp'))
